import React from 'react'
import _ from 'lodash'

import { booleanToText } from 'utils/functions'

import Container from './styles'

const DcbeReceiptValues = ({ filesData }) => {
  if (_.isEmpty(filesData)) return <span>DCBE: Nenhum arquivo de Recibo</span>

  return (
    <Container>
      <h2><ul><li>Recibo</li></ul></h2>

      {_.map(filesData, (fileData, fileIndex) => {
        const receiptData = fileData.receipt || {}

        return (
          <div className="values-file-container" key={fileIndex.toString()}>
            <div className="text-container">
              <p>
                <span>{`Arquivo #${fileIndex + 1}:`}</span>
                {' '}
                <span className="file-name">{fileData.name}</span>
              </p>

              <p>
                <strong>{`Recibo Valido: ${booleanToText(receiptData.valid)}`}</strong>
              </p>
            </div>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Valores do Recibo</th>
                    <th>Valores iguais aos da declaração</th>
                  </tr>
                </thead>
                <tbody>

                  <tr>
                    <td>
                      <strong>CPF:</strong>
                      {' '}
                      <span>{receiptData.cpf}</span>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <span>{booleanToText(receiptData.cpf_valid)}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Nome:</strong>
                      {' '}
                      <span>{receiptData.name}</span>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <span>{booleanToText(receiptData.name_valid)}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Status:</strong>
                      {' '}
                      <span>{receiptData.status}</span>
                    </td>
                    <td>
                      <span>{booleanToText(receiptData.status_valid)}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <strong>Ano Base:</strong>
                      {' '}
                      <span>{receiptData.year_base}</span>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <span>{booleanToText(receiptData.year_base_valid)}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        )
      })}
    </Container>
  )
}

export default DcbeReceiptValues
